export default __webpack_public_path__ + "static/media/FloorIcon.9cd4fb55.svg";